import React from 'react'
import "./UserAddscreen.css"
import { useNavigate } from 'react-router-dom';
const UserAddscreen = () => {
   const navigate = useNavigate();
  return (
    <> <div className="userAddScreenColumn_three">
    <div className="rowthumbsup_one">
      <div className="column_two">
        <div className="column_one-1">
          <div className="userAddScreenColumn-1">
            <div className="columnthumbsup">
              <img src="" alt="Image" className="image" />
              <img src="" alt="Thumbsup" className="thumbsup_one" />
            </div>
          </div>
          <div className="columnrayandipb">
            <h1 className="enterotp ui heading size-headinglg">
              Rayandip Biswas
            </h1>
            <div className="rowemail">
              <p className="email ui text size-textxs">rayandip.ui@gmail.com</p>
              <div className="row91983214027">
                <p className="class-91983214027 ui text size-textxs">
                  +91 983214027
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="columnmyorders">
          <div className="rowmyorders">
            <p className="myorders ui text size-textmd">My Orders</p>
            <img src="" alt="Arrowright" className="arrowright_one" />
          </div>
          <div className="rowmyaddress">
            <p className="myorders ui text size-textmd">My Address</p>
            <img src="" alt="Arrowright" className="arrowright_one" />
          </div>
          <div className="rowmyorders">
            <p className="myorders ui text size-textmd">Wishlist</p>
            <img src="" alt="Arrowright" className="arrowright_one" />
          </div>
          <div className="rowmyorders">
            <p className="myorders ui text size-textmd">Logout</p>
            <img src="" alt="Arrowright" className="arrowright_one" />
          </div>
        </div>
      </div>
      <div className="rowcontrast_one">
        <div className="columnrayandip">
          <div className="user_addscreen">
            <div className="rowrayandip">
              <img src="" alt="Rayandip Biswas" className="rayandip_biswas" />
              <div className="columnhome">
                <div className="rowrayandipbisw">
                  <h2 className="rayandipbiswas-1 ui heading size-headinglg">
                    Rayandip Biswas
                  </h2>
                  <button className="flex-row-center-center home ui button teal_400 size-sm outline">
                    Home
                  </button>
                </div>
                <div className="columnmobilecou">
                  <div className="columncharaktal">
                    <p className="mobilecounter ui text size-textxl">
                      Charaktala, Near Shiv Mondir, Bangaon (North 24 Parganas)
                    </p>
                    <p className="mobilecounter ui text size-textxl">
                      Bongaon West Bengal - 743235
                    </p>
                  </div>
                  <p className="mobilecounter ui text size-textxl">
                    <span>Mobile:&nbsp;</span>
                    <span className="mobilecounter-span">9832140247</span>
                  </p>
                </div>
                <div className="rowremove">
                  <button className="flex-row-center-center remove ui button white_a700 size-md fill round">
                    REMOVE
                  </button>
                  <button className="flex-row-center-center edit ui button white_a700 size-md fill round">
                    EDIT
                  </button>
                </div>
              </div>
            </div>
            <div className="rowrayandip">
              <img src="" alt="Rayandip Biswas" className="rayandip_biswas" />
              <div className="columnhome">
                <div className="rowrayandipbisw">
                  <h3 className="rayandipbiswas-1 ui heading size-headinglg">
                    Rayandip Biswas
                  </h3>
                  <button className="flex-row-center-center home ui button teal_400 size-sm outline">
                    Office
                  </button>
                </div>
                <div className="columnmobilecou">
                  <div className="columncharaktal">
                    <p className="mobilecounter ui text size-textxl">
                      Charaktala, Near Shiv Mondir, Bangaon (North 24 Parganas)
                    </p>
                    <p className="mobilecounter ui text size-textxl">
                      Bongaon West Bengal - 743235
                    </p>
                  </div>
                  <p className="mobilecounter ui text size-textxl">
                    <span>Mobile:&nbsp;</span>
                    <span className="mobilecounter-span">9832140247</span>
                  </p>
                </div>
                <div className="rowremove">
                  <button className="flex-row-center-center remove ui button white_a700 size-md fill round">
                    REMOVE
                  </button>
                  <button className="flex-row-center-center edit ui button white_a700 size-md fill round">
                    EDIT
                  </button>
                </div>
              </div>
            </div>
          </div>
          <button className="flex-row-center-center add ui button deep_orange_700_01 size-5xl fill">
            ADD
          </button>
        </div>
      </div>
    </div>
  </div>
  </>
  )
}

export default UserAddscreen